"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSyncRedux = createSyncRedux;
exports.createCollectionSyncRedux = createCollectionSyncRedux;
const lib_1 = require("../reducers/lib.js");
const lib_2 = require("../actionCreators/lib.js");
function createSyncRedux(options) {
    return {
        syncActionCreator: (0, lib_2.createSyncActionCreatorDataValue)({
            name: options.name,
            syncVerb: options.syncVerb
        }),
        syncReducer: (0, lib_1.createSyncReducer)(options)
    };
}
function createCollectionSyncRedux(options) {
    return {
        syncActionCreator: (0, lib_2.createSyncActionCreator)({
            hasRequest: options.hasRequest,
            name: options.name,
            syncVerb: options.syncVerb
        }),
        syncReducer: (0, lib_1.createCollectionSyncReducer)(options)
    };
}
//# sourceMappingURL=lib.js.map